<template>
    <v-container fluid class="py-0 my-0 px-0 mx-0">
        <v-row align="center" justify="center" style="background-color: #ececec; padding-left: 190px; padding-right: 160px;">
            <v-col cols="6" class="text-h6">
                <a href="tel:+302109852175"><v-icon height="2px" color="#ad282d">mdi-phone</v-icon> 2109852175</a>
                <a href="mailto:contact@paron-card.gr"><v-icon height="2px" color="#ad282d" class="pl-4">mdi-email</v-icon> contact@paron-card.gr</a>
            </v-col>
            <v-col class="noraml-text" cols="6" align="end">
                <v-btn
                    icon
                    href="https://www.youtube.com/channel/UC4E83cf5r0kA5768eU7ArZQ"
                    target="_blank"
                >
                    <v-icon color="#1b2f5a">
                        mdi-youtube
                    </v-icon>
                </v-btn>
                <v-btn
                    icon
                    href="https://www.facebook.com/profile.php?id=100085421851501"
                    target="_blank"
                    class="mx-3" 
                >
                    <v-icon color="#1b2f5a">
                        mdi-facebook
                    </v-icon>
                </v-btn>
                <v-btn
                    icon
                    href="https://www.instagram.com/paroncard/ "
                    target="_blank"
                >
                    <v-icon color="#1b2f5a">
                        mdi-instagram
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters class="px-0 mx-0" justify="center" align="center">
            <v-col cols="12" align="center">
                <v-img
                    width="150px"
                    contain
                    :src="require('@/assets/MEMBERSPARON_LOGO.svg')"
                    style="filter: drop-shadow(0 0 10px white);"
                    @click="$router.push({name: 'Homepage'})"
                />
                    <v-tabs
                        hide-slider
                        :show-arrows="false"
                        centered
                    >
                        <v-tab 
                            v-for="(item, index) in menu"
                            :key="index"
                            active-class="red-button"
                            style="font-size: 22px; text-transform: none !important; color: #1b2f5a;"
                            :to="item.route"
                            @click = "menuActionClick(item.route)"
                        >
                            {{language=='Ελληνικά'? item.title : item.entitle}}
                        </v-tab>
                    </v-tabs>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        data: () => ({
            drawer: false,
            languages: ['Ελληνικά', 'English'],
            menu: [
                {
                    route: 'HomePage', 
                    title: 'Αρχική',
                    entitle: 'Home'
                },
                {
                    route: 'AboutUs', 
                    title: 'PARON CARD',
                    entitle: 'About Us'
                },
                { 
                    route: 'Partners',
                    title: 'Επιχειρήσεις/Εκπτώσεις',
                    entitle: 'Partners'
                }
            ]
        }),
        computed: {
            language() {
                return this.$store.getters.getLanguage.language
            }
        },
        methods: {
            menuActionClick(route) {
                var newPath = '/'+route;
                if(this.$route.path != newPath){
                    this.$router.push({path: newPath})
                }
            },
            goToHome() {
                this.$router.push({name: 'Homepage'});
            },
            selectLanguage(item) {
                this.$store.dispatch("setLanguage", item)
            }
        }
    }
</script>

<style lang="scss" scoped>
.red-button{
    color: #ad282d !important;
}
.logo-pos{
    position: flex;
  }

  .theme--dark.v-app-bar.v-toolbar.v-sheet {
    // background-color: #ffffffab;
    background-color: transparent;
  }
  .theme--light.v-app-bar.v-toolbar.v-sheet {
    // background-color: #ffffffab;
    background-color: transparent;
  }
  .v-btn--icon.v-size--default .v-icon, .v-btn--fab.v-size--default .v-icon{
    font-size: 35px;
    color: #1b2f5a;
  }

  .sub-menu {
    font-size: 17px;
    color: #1b2f5a !important;
  }

  .noraml-text{
        font-size: 10px!important;
        color:#1b2f5a;
    }
    a {
        color: #1b2f5a !important; /* blue colors for links too */
        text-decoration: none; /* no underline */
    }
</style>

